module.exports = "/images/chevron-left.svg";